/**
 * CustomerSection.tsx
 * メール, 電話, 住所, 宿泊先, 過去予約回数(read-only)
 */
import React from 'react';
import { SectionProps } from '../types';
import SectionHeader from '../shared/SectionHeader';
import InlineEditField from '../shared/InlineEditField';
import FieldDisplay from '../shared/FieldDisplay';

export default function CustomerSection({
  data,
  onChange,
  disabled,
  onOpenEdit,
}: SectionProps) {
  return (
    <>
      <SectionHeader title="顧客情報" />
      <InlineEditField
        label="メール"
        field="customer_email"
        value={data.customer_email}
        onChange={onChange}
        disabled={disabled}
        type="email"
      />
      <InlineEditField
        label="電話番号"
        field="customer_tel"
        value={data.customer_tel}
        onChange={onChange}
        disabled={disabled}
        type="tel"
      />
      <InlineEditField
        label="住所"
        field="customer_address"
        value={data.customer_address}
        onChange={onChange}
        disabled={disabled}
        type="textarea"
      />
      <InlineEditField
        label="宿泊先"
        field="hotel"
        value={data.hotel}
        onChange={onChange}
        disabled={disabled}
      />
      <FieldDisplay
        label="過去予約回数"
        value={data.past_reservation_count ?? 0}
        suffix="回"
      />
    </>
  );
}
